import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AuthService } from 'app/auth/auth.service';
import { UserUpdateRequest, Area, Link, IndicatorValidationHelper } from 'app/shared/objects/cities';
import { IndicatorAdminHelper } from 'app/shared/objects/indicator';


@Injectable()
export class FormIndicatorsService {

  constructor(private http: HttpClient, private authService: AuthService) {
  }

  postIndicators(cityID: string, uuId: any, form: UserUpdateRequest): Promise<UserUpdateRequest> {
    return this.http.post(environment.apiURL + '/frontEndOpen/sendCityIndicators/' + cityID + '/' + uuId, form)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }
  getIndicators(cityID: string, uuId: any): Promise<Link> {
    return this.http.get(environment.apiURL + '/frontEndOpen/getSubmitedIndicators/' + cityID + '/' + uuId)
      .toPromise()
      .then(response => {
        return response as Link;
      })
      .catch(error => {
        return null;
      });
  }
  getAreas(): Promise<Area[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/areas')
      .toPromise()
      .then(response => {
        return response as Area[];
      })
      .catch(error => {
        return null;
      });
  }

  getIndicatorsList(): Promise<IndicatorAdminHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/indicatorsAll')
      .toPromise()
      .then(response => {
        return response as IndicatorAdminHelper[];
      })
      .catch(error => {
        return null;
      });
  }

  getSubmitedIndicators(cityID: string, uuId: any): Promise<Link> {
    return this.http.get(environment.apiURL + '/frontEndOpen/getSubmitedIndicators/' + cityID + '/' + uuId)
      .toPromise()
      .then(response => {
        return response as Link;
      })
      .catch(error => {
        return null;
      });
  }

  getIndicatorsValidation(): Promise<IndicatorValidationHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/getIndicatorsValidation')
      .toPromise()
      .then(response => {
        return response as IndicatorValidationHelper[];
      })
      .catch(error => {
        return null;
      });
  }
}
